import React from "react";
import { IconButton, makeStyles, Tooltip } from "@material-ui/core";
import Edit from "@material-ui/icons/Edit";

export default function EditIconButton(props) {
	const { tooltipTitle, onClick } = props;
	const classes = useStyles();
	return (
		<IconButton className={`${classes.edit} ${classes.iconButton}`} onClick={onClick}>
			<Tooltip title={tooltipTitle} aria-label="edit">
				<Edit />
			</Tooltip>
		</IconButton>
	);
}

const useStyles = makeStyles((theme) => ({
	edit: {
		"&:hover": {
			"& svg": {
				fill: "#FFAB62",
			},
		},
	},
	iconButton: {
		"& svg": {
			fill: theme.palette.primary.main,
		},
	},
}));
